// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".AriaLive__AriaLive___11r0y{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}", ""]);
// Exports
exports.locals = {
	"AriaLive": "AriaLive__AriaLive___11r0y"
};
module.exports = exports;
